import {postMethod} from '~/api'

async function post(formData) {
    return await postMethod('/api/import/supplier-credentials', formData, {'Content-Type': 'multipart/form-data'})
}

export {post}
